export default __webpack_public_path__ + "static/done-ac2890094f589f85d8a970564bf2159d.png";